export default {
    parts: ['container', 'link', 'mediaContainer', 'image', 'caption'],
    baseStyle: {
        container: {position: 'relative', width: '100%'},
        link: {
            position: 'absolute',
            inset: 0,
            zIndex: 1,
            textDecoration: 'none',
            _hover: {textDecoration: 'none'},
            _focusVisible: {
                outline: '2px solid',
                outlineColor: 'black',
                outlineOffset: '2px',
                zIndex: 2
            }
        },
        mediaContainer: {position: 'relative', width: '100%', aspectRatio: '2 / 3', overflow: 'hidden'},
        image: {width: '100%', height: '100%', objectFit: 'cover', display: 'block'},
        caption: {
            marginTop: '8px',
            paddingBottom: {base: '14px', lg: 0},
            textStyle: 'labelXs',
            textTransform: 'none',
            fontSize: {base: '12px', md: '14px'},
            color: 'black'
        }
    }
}